export enum IncidentEmailStatus {
    NotSent = 1,
    Sent = 2,
    Failed = 3,
}
